import { NgxSpinnerService } from 'ngx-spinner';
import { WalletService } from './../../../core/services/wallet.service';
import { Component, OnInit, Input, HostListener, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EnterOtpComponent } from '../enter-otp/enter-otp.component';

import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { FormBuilder, Validators } from '@angular/forms';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';

@Component({
  selector: 'app-enter-mobile',
  templateUrl: './enter-mobile.component.html',
  styleUrls: ['./enter-mobile.component.scss']
})
export class EnterMobileComponent implements OnInit {

  @Input() public giftUserData;

  mobileNumberForm: any;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  submitted: boolean = false;

  @ViewChild('ngxintltelinput', { static: false }) ngxintltelinput: any;
  @ViewChild('ngxintltelinputDiv', { static: false }) ngxintltelinputDiv: any;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _walletService: WalletService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.mobileNumberForm = this.formBuilder.group({
      phone_number: ['', [Validators.required]]
    });
  }
  closeDialog() {
    this.activeModal.dismiss();
  }

  onSubmit() {
    this.submitted = true;

    if (this.mobileNumberForm.invalid) {
      return;
    }

    let mobile = this.mobileNumberForm.value.phone_number.internationalNumber.replace(REGEX_PATTERNS.MOBILE_CLEAN, '')
    const params = {
      'phone_number': mobile.replace('-', ''),
      'is_number_change':true
    };

    this.spinner.show();
    this._walletService.getOTP(params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.openEnterOTP(params,true);
        }
        else if(response.message) {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.message === 'Authenticate'? 'Sorry,Something went wrong. Please try again after some time.':response.message;
        } else if(response.errors){
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = response.errors;
        }
      });
  }

  openEnterOTP(params,numFlag) {
    let modalRef;
    if (this.giftUserData.source === 'addToken' || this.giftUserData.source === 'giftToken' || this.giftUserData.source === 'transferToken' || this.giftUserData.source === 'withdrawtoken') {
      modalRef = this.modalService.open(EnterOtpComponent, { centered: true, backdrop: false });
      modalRef.componentInstance.numFlag = numFlag;
    } else {
      this.closeDialog();
      modalRef = this.modalService.open(EnterOtpComponent, { centered: true });
      modalRef.componentInstance.numFlag = numFlag;
    }

    modalRef.componentInstance.giftUserData = this.giftUserData;
    modalRef.componentInstance.phone_number = { phone_number: this.mobileNumberForm.value.phone_number.number.replace(REGEX_PATTERNS.MOBILE_CLEAN, ''), country_code: this.mobileNumberForm.value.phone_number.dialCode };
    modalRef.componentInstance.ico = this.ngxintltelinput.selectedCountry.iso2;
    modalRef.componentInstance.paramData = params;
    modalRef.result.then((result) => {
      if (result === 'success') {
        this.activeModal.close(result);
      } else {
        this.activeModal.dismiss();
      }
    }, (reason) => {
      if (reason == undefined) {
        this.activeModal.dismiss();
      }
    });

  }

  /**
   * Allow keyboard navigation for country code selector
   *
   * @param {KeyboardEvent} event
   * @returns
   * @memberof SettingsComponent
   */
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.ngxintltelinput.countryList && event.keyCode === 13 && this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
      this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus').click();
      this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus').classList.remove("focus");
      return;
    }
    if (this.ngxintltelinput.countryList && [38, 40].includes(event.keyCode) && document.querySelector('.flag-container.show')) {
      event.preventDefault();
      if (this.ngxintltelinputDiv.nativeElement.querySelector('input') == document.activeElement) {
        this.ngxintltelinputDiv.nativeElement.querySelector('input').blur();
      }
      // document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      if (!this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
        this.ngxintltelinput.countryList.nativeElement.querySelector('.country').classList.add("focus");
      } else {
        let element = this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus');

        element.classList.remove("focus");
        if (event.keyCode == 40 && element.nextSibling) {
          while (!element.nextSibling.classList || !element.nextSibling.classList.contains('country')) {
            element = element.nextSibling;
          }
          element.nextSibling.classList.add('focus');
          element.nextSibling.scrollIntoView({ block: "nearest" });
        } else if (event.keyCode == 38 && element.previousSibling) {
          while (!element.previousSibling.classList || !element.previousSibling.classList.contains('country')) {
            element = element.previousSibling;
            if (!element.previousSibling) {
              break;
            }
          }
          if (element.previousSibling != null) {
            element.previousSibling.classList.add('focus');
            // element.nextSibling.nextSibling.nextSibling.nextSibling.scrollIntoView({ block: "end" });
            element.previousSibling.scrollIntoView({ block: "nearest" });
          }
        }
      }
    }
  }
  scrollTop() {
    if (this.ngxintltelinput.countryList) {
      let ax = this.ngxintltelinput.countryList.nativeElement.querySelector('.country#ax');
      if (ax) {
        ax.scrollIntoView({ block: "nearest" });
      }
    }

  }

  /**
	 * Search country based on country name, iso2, dialCode or all of them.
	 */
  searchCountry(event) {
    if (event.keyCode != 38 && event.keyCode != 40 && this.ngxintltelinput && this.ngxintltelinput.countryList && this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
      this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus').classList.remove("focus");
    }
    if (!this.ngxintltelinput.countrySearchText || !this.ngxintltelinput.countryList) {
      // this.countryList.nativeElement.querySelector('li').scrollIntoView({ behavior: 'smooth' });
      return;
    }

    const countrySearchTextLower = this.ngxintltelinput.countrySearchText.toLowerCase();
    const country = this.ngxintltelinput.allCountries.filter(c => {
      if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.All) > -1) {
        // Search in all fields
        if (c.iso2.toLowerCase().startsWith(countrySearchTextLower)) {
          return c;
        }
        if (c.name.toLowerCase().startsWith(countrySearchTextLower)) {
          return c;
        }
        if (c.dialCode.startsWith(this.ngxintltelinput.countrySearchText)) {
          return c;
        }
      } else {
        // Or search by specific SearchCountryField(s)
        if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.Iso2) > -1) {
          if (c.iso2.toLowerCase().startsWith(countrySearchTextLower)) {
            return c;
          }
        }
        if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.Name) > -1) {
          if (c.name.toLowerCase().startsWith(countrySearchTextLower)) {
            return c;
          }
        }
        if (this.ngxintltelinput.searchCountryField.indexOf(SearchCountryField.DialCode) > -1) {
          if (c.dialCode.startsWith(this.ngxintltelinput.countrySearchText)) {
            return c;
          }
        }
      }
    });

    if (country.length > 0) {
      const el = this.ngxintltelinput.countryList.nativeElement.querySelector('#' + country[0].iso2);
      if (el) {
        if (!this.ngxintltelinput.countryList.nativeElement.querySelector('.country.focus')) {
          el.classList.add('focus');
        }
        this.scrollTop();
        el.scrollIntoView({ block: 'nearest' });
      }
    }

    this.checkSeparateDialCodeStyle();
    return;
  }

  /**
   * Scrolling to end of page bug fix
   *
   * @private
   * @memberof SettingsComponent
   */
  private checkSeparateDialCodeStyle() {
    if (this.separateDialCode && this.ngxintltelinput.selectedCountry) {
      var cntryCd = this.ngxintltelinput.selectedCountry.dialCode;
      this.ngxintltelinput.separateDialCodeClass = 'separate-dial-code iti-sdc-' + (cntryCd.length + 1);
    } else {
      this.ngxintltelinput.separateDialCodeClass = '';
    }
  }

  inputClick(e){
    if(this.ngxintltelinputDiv.nativeElement && this.ngxintltelinputDiv.nativeElement.querySelector('#country-search-box')){
      this.ngxintltelinputDiv.nativeElement.querySelector('#country-search-box').setAttribute('autocomplete','off');
    }
  }
}
